module.exports = __webpack_public_path__ + "img/obch2.0a6e726b.svg";